import { RESOURCES } from "@/organisms/Form/components/ResourcesSectionForm/const"

import type { SastGuidanceAPI } from "@/api/useSettings.types"

export const FIELD_NAMES = {
  cweIds: "cweIds",
  detectionRulesIds: "detectionRulesIds",
  guidanceText: "guidanceText",
  canonicalText: "canonicalText",
  guidanceTestImpact: "guidance-test-impact",
  sessionId: "sessionId",
  name_details: "name_details"
}

export const getInitialValues = (data?: SastGuidanceAPI) => {
  if (!data)
    return {
      resources: RESOURCES.ALL,
      [RESOURCES.SPECIFIC]: [{}]
    }

  const isAllResources = Object.values(data.filters?.scope || {}).every(
    (resource) => {
      if (Array.isArray(resource)) return resource.length === 0

      return true
    }
  )

  return {
    name_details: data.name,
    resources: isAllResources ? RESOURCES.ALL : RESOURCES.SPECIFIC,
    [RESOURCES.SPECIFIC]: isAllResources
      ? [{}]
      : Object.entries(data.filters?.scope || {})
          .filter(([_, value]) => Array.isArray(value) && value.length > 0)
          .map(([type, value]) => ({
            type,
            value
          })),
    [FIELD_NAMES.cweIds]: data.filters?.cwes,
    [FIELD_NAMES.detectionRulesIds]: data.filters?.ruleIds,
    [FIELD_NAMES.guidanceText]: data.guidance,
    [FIELD_NAMES.sessionId]: null
  }
}
